/**
 * Created by mac on 9/25/20
 */

const LevelVersions = function () {

};

LevelVersions.prototype.reset = function () {

};